import { useGetPatientPrescriptions } from '@/hooks/patients/useGetPatientPrescriptions';
import { debounce } from 'lodash';
import { useRef, useState } from 'react';

export const usePrescriptionSearch = ({ patientId }: { patientId: number | undefined }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const debouncedSetSearchTerm = useRef(
    debounce((value: string) => {
      setSearchTerm(value);
    }, 250)
  ).current;

  const { data, isLoading, isSuccess, isError, refetch } = useGetPatientPrescriptions(
    { size: 50 },
    searchTerm,
    patientId || 0
  );

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => debouncedSetSearchTerm(e.target.value);

  const handleClearSearchInput = () => {
    setSearchTerm('');
  };

  const handleRefresh = () => {
    refetch();
  };

  return {
    searchTerm,
    data,
    isLoading,
    isSuccess,
    isError,
    handleRefresh,
    handleInputChange,
    handleClearSearchInput
  };
};
